import { useCallback, useRef } from 'react'
import { useNotification } from '@/Core/Hooks/useNotification'
import {
    HandleChatEventTask,
    isChatRealtimeEvent,
    type ChatEventEnvelope,
} from '../Tasks/HandleChatEventTask'

export { isChatRealtimeEvent }
export type { ChatEventEnvelope }

/**
 * Public API: a stable callback for chat publications from Centrifugo.
 * Mirrors useNotificationRealtime — CentrifugoConnector keeps it in a ref,
 * so the identity must not change across renders.
 *
 * useNotification returns fresh functions on every render, hence the ref
 * bridge: the stable callback always calls the latest showSuccess.
 */
export const useChatRealtime = () => {
    const { showSuccess } = useNotification()

    const showSuccessRef = useRef(showSuccess)
    showSuccessRef.current = showSuccess

    const onChatEvent = useCallback((envelope: ChatEventEnvelope) => {
        // A realtime handler must never throw: an exception here would ripple
        // into the shared Centrifugo subscription used by notifications too
        try {
            HandleChatEventTask(envelope, {
                showToast: (title, text, onOpen) =>
                    showSuccessRef.current(title, text, {
                        actionLabel: 'Відкрити чат',
                        onClick: onOpen,
                    }),
            })
        } catch (error) {
            console.warn('Chat realtime event handling failed:', error)
        }
    }, [])

    return { onChatEvent }
}
